export const colors = {
  white: '#ffffff',
  lightGray: '#f5f5f5',
  gray: '#eaeaea',
  gray2: '#E8E8E8',
  gray3: '#777777',
  gray4: '#444444',
  black: '#2B2B2B',
  dark: '#272727',
  darkRgba15: 'rgba(41,45,65, 0.15)',
  darkRgba25: 'rgba(41,45,65, 0.25)',
  darkRgba8: 'rgba(41,45,65, 0.08)',
  darkRgba5: 'rgba(41,45,65, 0.05)',
  line: '#D8DAE8',
  green600: '#16a34a',
  gren700: '#15803d',
  green900: '#14532d',
  orange500: '#f97316',
  red600: '#dc2626',
};

export const colorScheme = {
  primary: colors.gren700,
  secondary: colors.gray4,
  warning: colors.orange500,
  text: colors.dark,
};
